import { memo } from 'react';
import { type ClickableTextProps, ClickableText, type HasHrefOrOnPress } from 'ClickableText';

// We do not include ValidWrapProps because inline links are always configured to wrap. For that
// reason, they cannot support icons. See comment near AllowWrapProps for an explanation of why
// those are connected.
// children is optional so that InlineLink can be used as a Trans component where the children
// are injected from the translation string at render time.
type InlineLinkProps = HasHrefOrOnPress &
    Pick<ClickableTextProps, 'color' | 'className' | 'weight' | 'underline' | 'disabled'> & {
        children?: ClickableTextProps['children'];
    };

function InlineLinkComponent(props: InlineLinkProps) {
    const { children = null, ...rest } = props;

    return (
        <ClickableText allowWrap {...rest}>
            {children}
        </ClickableText>
    );
}

export const InlineLink = memo(InlineLinkComponent) as typeof InlineLinkComponent;
